import { render, staticRenderFns } from "./migrations.vue?vue&type=template&id=b511f332&scoped=true&"
import script from "./migrations.vue?vue&type=script&lang=js&"
export * from "./migrations.vue?vue&type=script&lang=js&"
import style0 from "./migrations.vue?vue&type=style&index=0&id=b511f332&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b511f332",
  null
  
)

export default component.exports